import { render, staticRenderFns } from "./test-template-view.vue?vue&type=template&id=e0fb372c&scoped=true&"
import script from "./test-template-view.vue?vue&type=script&lang=ts&"
export * from "./test-template-view.vue?vue&type=script&lang=ts&"
import style0 from "./test-template-view.vue?vue&type=style&index=0&id=e0fb372c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fb372c",
  null
  
)

export default component.exports